export default {
    defaultConfig: {
        locale: 'en',
    },

    install(Vue, {store}) {
        store.registerModule('i18n', require('../modules/i18nModule').default);

        store.commit('i18n/import', {
            locale: 'en',
            data: require('../translations/en').default,
        });
        store.commit('i18n/import', {
            locale: 'de',
            data: require('../translations/de').default,
        });

        Vue.$i18n = Vue.prototype.$i18n = {
            setLocale: locale => store.commit('i18n/setCurrentLocale', locale),
            set: (key, value, locale) => store.commit('i18n/set', {key, value, locale}),
            import: (locale, data) => store.commit('i18n/import', {locale, data}),
            getLocale: () => store.getters['i18n/getCurrentLocale'],
            get: (key, params, locale) => store.getters['i18n/get'](key, params, locale),
        };
        Vue.__ = Vue.prototype.__ = Vue.$i18n.get;
    },
};